import React from 'react';

const NotFoundPage = () => {
    const styles = {
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            backgroundColor: '#f0f0f0',
            fontFamily: 'Arial, sans-serif',
            color: '#333',
            textAlign: 'center',
        },
        title: {
            fontSize: '6rem',
            marginBottom: '1rem',
            color: '#007bff',
            animation: 'bounce 2s infinite',
        },
        message: {
            fontSize: '1.5rem',
            marginBottom: '2rem',
            color: '#555',
        },
        button: {
            padding: '0.75rem 1.5rem',
            fontSize: '1rem',
            color: '#fff',
            backgroundColor: '#007bff',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            textDecoration: 'none',
            transition: 'background-color 0.3s ease',
        },
        buttonHover: {
            backgroundColor: '#0056b3',
        },
    };

    return (
        <div style={styles.container}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="150"
                height="150"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#007bff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{animation: 'float 3s ease-in-out infinite'}}
            >
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12" y2="16"/>
            </svg>
            <h1 style={styles.title}>404</h1>
            <p style={styles.message}>Désolé, la page que vous recherchez est introuvable.</p>

            <a
                href="/"
                style={styles.button}
                onMouseEnter={(e) => e.target.style.backgroundColor = styles.buttonHover.backgroundColor}
                onMouseLeave={(e) => e.target.style.backgroundColor = styles.button.backgroundColor}
            >
                Retour à l'accueil
            </a>
            <style>
                {`
                    @keyframes bounce {
                        0%, 20%, 50%, 80%, 100% {
                            transform: translateY(0);
                        }
                        40% {
                            transform: translateY(-30px);
                        }
                        60% {
                            transform: translateY(-15px);
                        }
                    }
                    @keyframes float {
                        0%, 100% {
                            transform: translateY(0);
                        }
                        50% {
                            transform: translateY(-20px);
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default NotFoundPage;